// extracted by mini-css-extract-plugin
module.exports = {"root":"HealthCreateEdit_root__2c8Hb"};